import type { ExtractKeysWithDotNotation } from "@tellescope/ui";
import { useTypedSearchParams } from "../../../hooks/use-typed-search-params";

export interface SMSCompositionPanelQueryParams {
  composeTo?: {
    enduserId: string;
    number: string | number;
  };
  composeFrom?: {
    number: string | number;
  };
}

const VALID_SMS_COMPOSITION_PANEL_QUERY_PARAM_KEYS = [
  "composeTo.number",
  "composeTo.enduserId",
  "composeFrom.number",
] as const satisfies ExtractKeysWithDotNotation<SMSCompositionPanelQueryParams>[];

const SMS_COMPOSITION_PANEL_ARRAY_KEYS =
  [] as const satisfies ExtractKeysWithDotNotation<SMSCompositionPanelQueryParams>[];

export const useSMSCompositionPanelSearchParams = () => {
  return useTypedSearchParams<SMSCompositionPanelQueryParams>(
    VALID_SMS_COMPOSITION_PANEL_QUERY_PARAM_KEYS,
    SMS_COMPOSITION_PANEL_ARRAY_KEYS
  );
};
